// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/EventCalendar/calendar.css
// module id = 2103
// module chunks = 0